
import React, { createContext, useContext, useState, useEffect } from 'react';

interface AccessCodeContextType {
  isAuthenticated: boolean;
  authenticate: (code: string) => boolean;
  logout: () => void;
}

const AccessCodeContext = createContext<AccessCodeContextType | undefined>(undefined);

export const useAccessCode = () => {
  const context = useContext(AccessCodeContext);
  if (context === undefined) {
    throw new Error('useAccessCode must be used within an AccessCodeProvider');
  }
  return context;
};

interface AccessCodeProviderProps {
  children: React.ReactNode;
}

export const AccessCodeProvider = ({ children }: AccessCodeProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user is already authenticated on mount
  useEffect(() => {
    const savedAuth = localStorage.getItem('doozy-authenticated');
    if (savedAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const authenticate = (code: string): boolean => {
    // Valid access codes
    const validCodes = ['BYTEHYPE', 'DOOZY2024', 'PREMIUM'];
    
    if (validCodes.includes(code.toUpperCase())) {
      setIsAuthenticated(true);
      localStorage.setItem('doozy-authenticated', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('doozy-authenticated');
  };

  return (
    <AccessCodeContext.Provider value={{ isAuthenticated, authenticate, logout }}>
      {children}
    </AccessCodeContext.Provider>
  );
};
